import type { ReactElement } from 'react'

function dots(points: readonly (readonly [number, number])[]): ReactElement {
  return (
    <>
      {points.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r={1.6} fill="currentColor" stroke="none" />
      ))}
    </>
  )
}

// Cesty 1:1 z design/vice-uzivatelu/generuj.py (ICONS); posledni blok jsou
// ikony navic kreslene stejnym tahem, at ladi.
const ICONS = {
  chevron_down: <path d="M6 9l6 6 6-6" />,
  chevron_up: <path d="M18 15l-6-6-6 6" />,
  chevron_left: <path d="M15 18l-6-6 6-6" />,
  chevron_right: <path d="M9 6l6 6-6 6" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  bell: (
    <>
      <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16z" />
      <path d="M10 20.5a2 2 0 0 0 4 0" />
    </>
  ),
  filter: <path d="M4 6h16M7 12h10M10 18h4" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  more: dots([
    [5, 12],
    [12, 12],
    [19, 12],
  ]),
  grip: dots([
    [9, 6],
    [15, 6],
    [9, 12],
    [15, 12],
    [9, 18],
    [15, 18],
  ]),
  share: (
    <>
      <path d="M12 15V3" />
      <path d="M7.5 7.5L12 3l4.5 4.5" />
      <path d="M5 12v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V6a2 2 0 0 1 2-2h9" />
    </>
  ),
  link: (
    <>
      <path d="M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1" />
      <path d="M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1" />
    </>
  ),
  user_plus: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M19 8v6M16 11h6" />
    </>
  ),
  store: (
    <>
      <path d="M4.5 11v9h15v-9" />
      <path d="M3 10l1.8-6h14.4L21 10a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z" />
      <path d="M10 20v-5h4v5" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </>
  ),
  arrow_right: <path d="M5 12h14M13 6l6 6-6 6" />,
  cloud_check: (
    <>
      <path d="M7 18h10a4 4 0 0 0 .5-7.97A6 6 0 0 0 6.1 9.2 4.5 4.5 0 0 0 7 18z" />
      <path d="M9.5 13.5l2 2 3.5-3.5" />
    </>
  ),
  list_check: (
    <>
      <path d="M11 6h9M11 12h9M11 18h9" />
      <path d="M3.5 6l1.5 1.5L8 4.5M3.5 12l1.5 1.5L8 10.5M3.5 18l1.5 1.5L8 16.5" />
    </>
  ),
  tag: (
    <>
      <path d="M3 12V4h8l10 10-8 8z" />
      <circle cx="7.5" cy="8.5" r="1.3" />
    </>
  ),
  x_circle: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 9l6 6M15 9l-6 6" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M10 11v6M14 11v6" />
      <path d="M6 7l1 13h10l1-13M9 7V4h6v3" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  pencil: (
    <>
      <path d="M4 20h4L19 9l-4-4L4 16z" />
      <path d="M13.5 6.5l4 4" />
    </>
  ),
  basket: (
    <>
      <path d="M3 9.5h18l-2 10.5H5z" />
      <path d="M8 9.5a4 4 0 0 1 8 0" />
      <path d="M10 13.5v3M14 13.5v3" />
    </>
  ),
  bag: (
    <>
      <path d="M5.5 8h13l-1 12h-11z" />
      <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4 4" />
    </>
  ),

  logout: (
    <>
      <path d="M9 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3" />
      <path d="M15 16.5l4.5-4.5L15 7.5" />
      <path d="M19.5 12H9" />
    </>
  ),
  settings: (
    <>
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="15" cy="7" r="2" />
      <circle cx="9" cy="17" r="2" />
    </>
  ),
  alert: (
    <>
      <path d="M10.27 4.5a2 2 0 0 1 3.46 0l7.5 13A2 2 0 0 1 19.5 20.5h-15a2 2 0 0 1-1.73-3z" />
      <path d="M12 9.5v4" />
      <circle cx="12" cy="17" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  wifi_off: (
    <>
      <path d="M3 3l18 18" />
      <path d="M8.8 15.6a4.5 4.5 0 0 1 6.4 0" />
      <path d="M5.5 12.2a9 9 0 0 1 4-2.3M18.5 12.2a9 9 0 0 0-2.3-1.6" />
      <path d="M2.5 8.8a13.5 13.5 0 0 1 3.4-2.3M21.5 8.8A13.5 13.5 0 0 0 10.5 5.3" />
      <circle cx="12" cy="19.5" r="1.3" fill="currentColor" stroke="none" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 12a8 8 0 1 1-2.34-5.66L20 8.5" />
      <path d="M20 4v4.5h-4.5" />
    </>
  ),
  // Z design/sklo/kit.py (ICONS).
  users: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16 4.8a3.5 3.5 0 0 1 0 6.4" />
      <path d="M18.5 14.2a6.5 6.5 0 0 1 3 5.8" />
    </>
  ),
  printer: (
    <>
      <path d="M7 9V3.5h10V9" />
      <rect x="3.5" y="9" width="17" height="8" rx="2" />
      <path d="M7 14h10v6.5H7z" />
    </>
  ),
  selector: (
    <>
      <path d="M8 9.5l4-4 4 4" />
      <path d="M8 14.5l4 4 4-4" />
    </>
  ),
  barcode: (
    <>
      <path d="M3.5 7.5V5A1.5 1.5 0 0 1 5 3.5h2.5M16.5 3.5H19A1.5 1.5 0 0 1 20.5 5v2.5M20.5 16.5V19a1.5 1.5 0 0 1-1.5 1.5h-2.5M7.5 20.5H5A1.5 1.5 0 0 1 3.5 19v-2.5" />
      <path d="M7.5 8v8M10.5 8v8M13 8v8M16.5 8v8" />
    </>
  ),
  // Kategorie akci (navrh v2).
  cat_produce: (
    <>
      <path d="M12 7c-1.2-1.4-3.4-1.8-5-1C4.4 7.3 3.7 10.8 4.8 14c1.1 3.4 3.4 6.8 5.6 6.4.7-.1 1-.6 1.6-.6s.9.5 1.6.6c2.2.4 4.5-3 5.6-6.4 1.1-3.2.4-6.7-2.2-8-1.6-.8-3.8-.4-5 1z" />
      <path d="M12 7c0-2 1-3.6 3-4.4" />
    </>
  ),
  cat_meat: (
    <>
      <path d="M13.5 15.5c3.9 1.5 8-1.3 8-5.5a6.5 6.5 0 0 0-11-4.7c-2 1.9-2.4 5-1.2 7.4L5.7 16.3a1.8 1.8 0 1 0-1 2.9 1.8 1.8 0 1 0 2.9-1z" />
      <circle cx="15.5" cy="9.5" r="1.5" />
    </>
  ),
  cat_dairy: (
    <>
      <path d="M8 2.5h8M9 2.5V6L6.5 9.5V20A1.5 1.5 0 0 0 8 21.5h8a1.5 1.5 0 0 0 1.5-1.5V9.5L15 6V2.5" />
      <path d="M6.5 13.5h11" />
    </>
  ),
  cat_bakery: (
    <>
      <path d="M5 11a4 4 0 0 1 1-7.7C7.5 3 9.8 3 12 3s4.5 0 6 .3A4 4 0 0 1 19 11v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z" />
      <path d="M9 11v4M15 11v4" />
    </>
  ),
  cat_pantry: (
    <>
      <path d="M21 8l-9-5-9 5 9 5z" />
      <path d="M3 8v8l9 5 9-5V8M12 13v8" />
    </>
  ),
  cat_sweets: (
    <>
      <circle cx="12" cy="12" r="4.2" />
      <path d="M8.8 9.2L5 5.5 3.5 8.6l2.2.7-.6 2.3 3.1-.6M15.2 14.8l3.8 3.7 1.5-3.1-2.2-.7.6-2.3-3.1.6" />
    </>
  ),
  cat_frozen: (
    <>
      <path d="M12 2.5v19M3.8 7.2l16.4 9.6M20.2 7.2L3.8 16.8" />
      <path d="M9 4.5l3 2 3-2M9 19.5l3-2 3 2" />
    </>
  ),
  cat_drinks: (
    <>
      <path d="M17 8h1a4 4 0 0 1 0 8h-1" />
      <path d="M3 8h14v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5z" />
      <path d="M7 2.5V5M11 2.5V5" />
    </>
  ),
  cat_alcohol: <path d="M8 21.5h8M12 15v6.5M7 2.5h10l-.4 5.5a4.6 4.6 0 0 1-9.2 0z" />,
  cat_drugstore: (
    <>
      <path d="M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9z" />
      <path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
    </>
  ),
  cat_home: <path d="M3.5 10.5L12 3.5l8.5 7V20a1 1 0 0 1-1 1H15v-6H9v6H4.5a1 1 0 0 1-1-1z" />,
  cat_pets: (
    <>
      <circle cx="5.5" cy="10" r="2" />
      <circle cx="9.5" cy="5.5" r="2" />
      <circle cx="14.5" cy="5.5" r="2" />
      <circle cx="18.5" cy="10" r="2" />
      <path d="M12 12c-3 0-5.5 3.6-5.5 6.1 0 1.7 1.3 2.4 2.7 2.4 1.2 0 1.8-.6 2.8-.6s1.6.6 2.8.6c1.4 0 2.7-.7 2.7-2.4 0-2.5-2.5-6.1-5.5-6.1z" />
    </>
  ),
  cat_tools: (
    <>
      <path d="M14 10l-9.3 9.3a1.8 1.8 0 0 0 2.6 2.6l9.3-9.3" />
      <path d="M12.5 3.5L21 12l-2.5 2.5-2-2-2.2 2.2-3-3 2.2-2.2-2-2z" />
    </>
  ),
  cat_electronics: (
    <>
      <rect x="2.5" y="5" width="19" height="13" rx="2" />
      <path d="M8 21.5h8M12 18v3.5" />
    </>
  ),
  cat_clothes: (
    <path d="M20.4 6.5L16 3.5a4 4 0 0 1-8 0L3.6 6.5a1 1 0 0 0-.4 1.2l1.4 3.4a1 1 0 0 0 1.2.6L7 11.3V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8.7l1.2.4a1 1 0 0 0 1.2-.6l1.4-3.4a1 1 0 0 0-.4-1.2z" />
  ),
  cat_other: (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
    </>
  ),
} satisfies Record<string, ReactElement>

export type IconName = keyof typeof ICONS

export function Icon({
  name,
  size = 20,
  strokeWidth = 1.8,
  className,
}: {
  name: IconName
  size?: number | undefined
  strokeWidth?: number | undefined
  className?: string | undefined
}) {
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {ICONS[name]}
    </svg>
  )
}
